import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';
import type { RootState } from '~/store';
import type {
    RoutePlanEditSuggestionState,
    RoutePlanEditSuggestion
} from './types';

const initialRoutePlanEditSuggestionState =
    null as RoutePlanEditSuggestionState;

export const routePlanEditSuggestionSlice = createSlice({
    name: 'routePlanEditSuggestion',
    initialState: initialRoutePlanEditSuggestionState,
    reducers: {
        setRoutePlanEditSuggestion: (
            state: RoutePlanEditSuggestionState,
            action: PayloadAction<RoutePlanEditSuggestion>
        ) => {
            return action.payload;
        },
        resetRoutePlanEditSuggestion: (): RoutePlanEditSuggestionState => {
            return initialRoutePlanEditSuggestionState;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return initialRoutePlanEditSuggestionState;
        });
    }
});

export const { setRoutePlanEditSuggestion, resetRoutePlanEditSuggestion } =
    routePlanEditSuggestionSlice.actions;

export const selectRoutePlanEditSuggestion = (state: RootState) =>
    state.routePlanEditSuggestion;

export default routePlanEditSuggestionSlice.reducer;
